import { ACTIONS_INTEGRATION } from '../../constants.js';

export function messageIntegration(data){
  return {
    type : ACTIONS_INTEGRATION.MESSAGE,
    dataIntegration : data,
  };
}

export function changeIsIntegration(){
  return {
    type: ACTIONS_INTEGRATION.CHANGE_IS_INTEGRATION,
  }
}




// WEBPACK FOOTER //
// ./src/redux/actions/A_actions_Integration.js